module.exports = __webpack_public_path__ + "img/analysis-results-update-mobile-en.e17d3179.jpg";